<iframe
  #iframe
  [class.debug]="isDebug"
  [scrolling]="isDebug ? 'yes' : 'no'"
  [src]="iframeUrl | sanitize: 'RESOURCE_URL'"
  title="Heidelpay"
></iframe>
<div
  [class.show-error]="showError$ | async"
  class="error alert alert-danger"
  i18n="@@payment_method.error.creditcard_form"
>
  Bitte prüfen Sie Ihre Angaben oben.
</div>
